<script setup lang="ts">
import GaiaHeader from '../base/GaiaHeader.vue';
import GaiaText from '../base/GaiaText.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  /** Second line under the title — a file path, a counterparty, a count. */
  subtitle: {
    type: String,
    default: undefined,
  },
});
</script>

<template>
  <!-- The detail-page title row: title with an inline #meta run (status, due
       date, a chip), and #actions pinned right. No back arrow: the way up is
       the layout's breadcrumb bar, so the row never duplicates it. Replaces
       the hand-rolled `n-page-header` the older detail views each built their
       own way, so the title, its meta and the action buttons keep one set of
       sizes and one baseline across pages. -->
  <n-flex align="center" :size="12" :wrap="false" :style="{ minWidth: 0 }">
    <n-flex vertical :size="2" :style="{ flex: '1 1 auto', minWidth: 0 }">
      <n-flex align="center" :size="10" :wrap="false" :style="{ minWidth: 0 }">
        <!-- `record`, not `screen`: this titles one document, and a review's
             title is a filename that has to be allowed to wrap. -->
        <gaia-header :level="1" size="record" :style="{ minWidth: 0 }">
          {{ props.title }}
        </gaia-header>
        <n-flex v-if="$slots.meta" align="center" :size="8" :wrap="false" :style="{ flex: 'none' }">
          <slot name="meta" />
        </n-flex>
      </n-flex>
      <gaia-text v-if="props.subtitle" size="meta" tone="subtle" truncate>
        {{ props.subtitle }}
      </gaia-text>
    </n-flex>

    <n-flex
      v-if="$slots.actions"
      align="center"
      justify="end"
      :size="8"
      :wrap="false"
      :style="{ flex: 'none' }"
    >
      <slot name="actions" />
    </n-flex>
  </n-flex>
</template>
